// @flow
import * as Immutable from "immutable";
import { handleActions, combineActions } from "redux-actions";
import { incrementD2, decrementD2, toggleD1 } from "./playActions";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  d1: true,
  d2: 0,
  sampleJs: {
    name: "Roy Wolfhard",
    yob: 2015
  }
});

const playReducer = handleActions(
  {
    [combineActions(incrementD2, decrementD2)](state, { payload: { amount } }) {
      // amount here is action.payload.amount
      return state.update("d2", e => e + amount);
    },
    [toggleD1](state, action) {
      return state.update("d1", e => !e);
    }
  },
  initialState
);

export { playReducer };



// WEBPACK FOOTER //
// ./src/features/play/playReducer.js